/**
 * Système de validation pour le formulaire de personnalisation
 * - Validation du formulaire complet
 * - Activation/désactivation du bouton d'ajout au panier
 */

document.addEventListener('DOMContentLoaded', () => {
  const mainProductElement = document.querySelector('[data-section-id]');
  if (!mainProductElement) return;

  const sectionId = mainProductElement.getAttribute('data-section-id');

  // Sélection des éléments
  const fields = {
    principal: {
      input: document.querySelector(`#texte_principal-${sectionId}`),
      error: document.querySelector(`#error-texte_principal-${sectionId}`)
    },
    secondaire: {
      input: document.querySelector(`#texte_secondaire-${sectionId}`)
    },
    verso: {
      input: document.querySelector(`#texte_verso-${sectionId}`)
    }
  };

  // Récupérer les autres éléments du formulaire
  const dimensionInputs = document.querySelectorAll('input[name="properties[Dimension]"]');
  const couleurInputs = document.querySelectorAll('input[name="properties[Couleur de fond]"]');
  const form = document.querySelector(`#personnalisation-form-${sectionId}`);
  const submitButton = document.querySelector(`#ProductSubmitButton-${sectionId}`);

  /**
   * Vérifier si le formulaire est complet
   */
  function updateFormCompletionStatus() {
    const isPrincipalFilled = fields.principal.input && fields.principal.input.value.trim();
    const isDimensionSelected = Array.from(dimensionInputs).some(input => input.checked);
    const isCouleurSelected = Array.from(couleurInputs).some(input => input.checked);

    const isFormComplete = isPrincipalFilled && isDimensionSelected && isCouleurSelected;

    // Ajouter une classe au formulaire pour indiquer qu'il est complet
    if (isFormComplete) {
      if (form) form.classList.add('form-complete');
      hideFormIncompleteIndicator();
      if (submitButton) {
        submitButton.disabled = false;
      }
    } else {
      if (form) form.classList.remove('form-complete');
      showFormIncompleteIndicator();
      if (submitButton) {
        submitButton.disabled = true;
      }
    }

    return isFormComplete;
  }

  /**
   * Afficher l'indicateur de formulaire incomplet
   */
  function showFormIncompleteIndicator() {
    let indicator = document.querySelector('.form-complete-indicator');
    if (!indicator) {
      indicator = document.createElement('div');
      indicator.className = 'form-complete-indicator';
      indicator.innerHTML = `
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24"><path fill="currentColor" d="M8.673 20L4 15.327V8.673L8.673 4h6.654L20 8.673v6.654L15.327 20H8.673Zm.477-4.442l2.85-2.85l2.85 2.85l.708-.708l-2.85-2.85l2.85-2.85l-.708-.708l-2.85 2.85l-2.85-2.85l-.708.708l2.85 2.85l-2.85 2.85l.708.708Z"/></svg>
        <span>Veuillez remplir toutes les options requises</span>
      `;

      const ctaSection = document.querySelector('.personnalisation__cta');
      if (ctaSection) {
        ctaSection.insertBefore(indicator, ctaSection.firstChild);
      }
    }

    indicator.style.display = 'flex';
  }

  /**
   * Masquer l'indicateur de formulaire incomplet
   */
  function hideFormIncompleteIndicator() {
    const indicator = document.querySelector('.form-complete-indicator');
    if (indicator) {
      indicator.style.display = 'none';
    }
  }

  /**
   * Initialiser les validations pour un champ
   */
  function initializeField(field) {
    if (!field.input) return;

    // Sauvegarder le message d'erreur original
    if (field.error) {
      field.error.setAttribute('data-original-message', field.error.textContent);
    }

    // Événement input
    field.input.addEventListener('input', () => {
      updateFormCompletionStatus();
    });

    // Événement blur
    field.input.addEventListener('blur', () => {
      updateFormCompletionStatus();
    });
  }

  // Initialiser tous les champs
  initializeField(fields.principal);
  initializeField(fields.secondaire);
  initializeField(fields.verso);

  // Écouter les changements de dimension
  dimensionInputs.forEach((input) => {
    input.addEventListener('change', () => {
      updateFormCompletionStatus();
    });
  });

  // Écouter les changements de couleur
  couleurInputs.forEach((input) => {
    input.addEventListener('change', () => {
      updateFormCompletionStatus();
    });
  });

  // Vérification initiale
  updateFormCompletionStatus();
});
